if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const menuToggle = document.querySelector('#navigation-toggler');
const navigation = document.querySelector('nav');
const navigationLinks = document.querySelectorAll('nav a');

/**
 * Append an "is-active" class to the menu when the toggle is clicked.
 */
menuToggle.addEventListener('click', event => {
    menuToggle.classList.toggle('is-active');
    navigation.classList.toggle('is-active');

    if (menuToggle.classList.contains('is-active')) {
        document.querySelector('body').style.overflow = 'hidden';
    } else {
        document.querySelector('body').style.overflow = 'initial';
    }
});

/**
 * When a navigation item has a submenu, we'll slide it down or up depending on its current state.
 */
Array.prototype.slice.call(navigationLinks).forEach(element => {
    element.addEventListener('click', event => {
        if (event.target.nextElementSibling && event.target.nextElementSibling.nodeName === 'UL') {
            slideToggle(event.target.nextElementSibling, 200);
        }
    });
});